var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 5.33331H6.66663C5.60576 5.33331 4.58834 5.75474 3.8382 6.50489C3.08805 7.25503 2.66663 8.27245 2.66663 9.33331V22.6666C2.66663 23.7275 3.08805 24.7449 3.8382 25.4951C4.58834 26.2452 5.60576 26.6666 6.66663 26.6666H25.3333C26.3942 26.6666 27.4116 26.2452 28.1617 25.4951C28.9119 24.7449 29.3333 23.7275 29.3333 22.6666V9.33331C29.3333 8.27245 28.9119 7.25503 28.1617 6.50489C27.4116 5.75474 26.3942 5.33331 25.3333 5.33331V5.33331ZM24.7866 7.99998L16.9466 15.84C16.8227 15.965 16.6752 16.0641 16.5127 16.1318C16.3502 16.1995 16.176 16.2344 16 16.2344C15.8239 16.2344 15.6497 16.1995 15.4872 16.1318C15.3247 16.0641 15.1772 15.965 15.0533 15.84L7.21329 7.99998H24.7866ZM26.6666 22.6666C26.6666 23.0203 26.5262 23.3594 26.2761 23.6095C26.0261 23.8595 25.6869 24 25.3333 24H6.66663C6.313 24 5.97387 23.8595 5.72382 23.6095C5.47377 23.3594 5.33329 23.0203 5.33329 22.6666V9.87998L13.1733 17.72C13.9233 18.469 14.94 18.8898 16 18.8898C17.06 18.8898 18.0766 18.469 18.8266 17.72L26.6666 9.87998V22.6666Z",
    fill: "#3F51B5",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c17e9b0d619c1850577ff332b00bc513.svg";
export { ForwardRef as ReactComponent };